import { Stack, StackPage, StackSwitch, usePersistedStateId } from "@comet/admin";
import { PageHeader } from "@src/components";
import { FormattedMessage, useIntl } from "react-intl";

import { EditTrapAlarm } from "./edit/EditTrapAlarm";
import Table from "./Table";

export default () => {
    const intl = useIntl();
    const persistedStateId = usePersistedStateId();

    return (
        <Stack topLevelTitle={intl.formatMessage({ id: "reviermanager.page.trapAlarm", defaultMessage: "Fallenalarme" })}>
            <StackSwitch initialPage="table">
                <StackPage name="table">
                    <PageHeader title={<FormattedMessage id="reviermanager.page.trapAlarm" defaultMessage="Fallenalarme" />} />

                    <Table persistedStateId={persistedStateId} />
                </StackPage>

                <StackPage
                    name="edit"
                    title={intl.formatMessage({ id: "reviermanager.page.trapAlarm.edit", defaultMessage: "Fallenalarm bearbeiten" })}
                >
                    {(id) => <EditTrapAlarm id={id} />}
                </StackPage>
            </StackSwitch>
        </Stack>
    );
};
